import React from "react";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { useHomeProducts } from "../../../api/queries/homeQueries";
import { TicketBox } from "../../../components/box/TicketBox";
import { UI } from "../../../config/ui";
import { useTranslationEx } from "../../../hooks/useTranslationEx";

const RecommendTicketSwiper: React.FC = () => {
  const { handleSlideChange, products } = useHomeProducts("TICKET", "tickets");
  return (
    <TicketBoxSwiper
      products={products}
      handleSlideChange={handleSlideChange}
    />
  );
};

export const TicketBoxSwiper: React.FC<{
  products: ProductBaseResponse[];
  handleSlideChange?: (swiper: any) => void;
}> = ({ products, handleSlideChange = () => {} }) => {
  const { t2 } = useTranslationEx({});
  return (
    <div className="relative">
      <Swiper
        modules={[Navigation]}
        onSlideChange={handleSlideChange}
        slidesPerView={"auto"}
        spaceBetween={16}
        breakpoints={{
          [UI.sm]: {
            slidesPerView: 4,
            spaceBetween: 22,
          },
        }}
        navigation={{
          nextEl: "#rcmd-ticket-next",
          prevEl: "#rcmd-ticket-prev",
        }}
        className=""
      >
        {products.map((ticket, index) => (
          <SwiperSlide key={index}>
            <TicketBox
              className="h-[18.75rem]"
              product={{
                ...ticket,
                name: t2(ticket.name),
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="swiper-button-prev" id="rcmd-ticket-prev">
        <img src="../../../assets/icons/swiper_prev_arrow.svg" alt="" />
      </div>
      <div className="swiper-button-next" id="rcmd-ticket-next">
        <img src="../../../assets/icons/swiper_next_arrow.svg" alt="" />
      </div>
    </div>
  );
};
export default RecommendTicketSwiper;
